'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

function useCopy() {
  const translate = useTranslations();
  const initialCopyText = translate('common.copy');

  const [copyText, setCopyText] = useState(initialCopyText);
  const hasCopied = copyText !== initialCopyText;

  const handleCopy = async (targetText: string) => {
    await navigator.clipboard.writeText(targetText);
    setCopyText(translate('share.copied'));
  };

  const resetCopyText = () => {
    setCopyText(initialCopyText);
  };

  return {
    resetCopyText,
    handleCopy,
    copyText,
    hasCopied,
  };
}

export default useCopy;
